import styled from 'styled-components';

import {
  Icon,
  Popup as SemanticPopup,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const CARD_WIDTH = 205;

export const ContainerClipBottom = styled.div`
  display: ${(props) => (props.isDragging ? 'none' : 'flex')};
  width: 200px;
  flex-direction: column;
  height: 120px;
  max-height: 120px;
  border: 1px solid ${(props) => (props.isPlaying ? props.theme.color.primary : '#DEDEDF')};
  border-radius: 4px;
  padding: 10px;

  ${(props) => (props.isOver && !props.isOverHalf && !props.isDragging && `
    margin-left: ${CARD_WIDTH}px;
  `)}

  margin-right: 5px;
  cursor: move;
`;

export const ClipBottomHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconClose = styled(Icon)`
  &&& {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    width: 25px;
    height: 25px;
  }
`;

export const ClipBottomTitle = styled(TextLayoutComponent)`
  font-size: 14px;
  font-weight: 500;
  color: #192c47;
`;

export const ClipBottomNote = styled(TextLayoutComponent)`
  font-size: 12px;
  margin: 5px 0;
  color: #4D5573;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ClipBottomFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  align-items: center;
`;

export const ClipBottomLink = styled.a`
  font-size: 12px;
  font-weight: 500;
`;

export const ContainerTag = styled.div`
    display: flex;
    background: #ECECEC;
    padding: 5px 10px;
    border-radius: 3px;
`;

export const IconTagHover = styled.img`
  width: 16px;
  height: 16px;
`;

export const PopupTag = styled(SemanticPopup)``;

export const ContainerMaxHeight = styled.div`
  max-height: 470px;
  overflow: auto;
`;

export const NumberTags = styled.div`
  margin-right: 5px;
`;
